import React from "react";
import "./ecosystem-verticals.css";

const GeometricPrismSection = () => {
  const prismData = [
    {
      id: 1,
      title: "Instant Loan Processing",
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#e94e4e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 12h18M12 3v18"/>
        </svg>
      ),
      description: "Quick approval and disbursement of loans within minutes."
    },
    {
      id: 2,
      title: "Flexible Repayment Options",
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#e94e4e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2"/>
          <path d="M3 9h18M9 21V9"/>
        </svg>
      ),
      description: "Repay loans in a way that suits the customer’s cash flow."
    },
    {
      id: 3,
      title: "Transparent Fees",
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#e94e4e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="6" x2="12" y2="12"/>
          <line x1="12" y1="12" x2="16" y2="14"/>
        </svg>
      ),
      description: "No hidden charges; everything is upfront and clear."
    },
    {
      id: 4,
      title: "Fast Eligibility Check",
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#e94e4e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 12l2 2 4-4"/>
          <circle cx="12" cy="12" r="10"/>
        </svg>
      ),
      description: "Instantly know your eligibility without filling long forms."
    },
    {
      id: 5,
      title: "24/7 Customer Support",
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#e94e4e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"/>
          <path d="M8 15l4-4 4 4"/>
        </svg>
      ),
      description: "Friendly support available anytime for loan-related queries."
    },
    {
      id: 6,
      title: "Secure Transactions",
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#e94e4e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 1L3 5v6c0 5 3.8 9 9 9s9-4 9-9V5l-9-4z"/>
          <path d="M12 11v4"/>
          <path d="M12 7h.01"/>
        </svg>
      ),
      description: "All payments and personal data are protected using top security standards."
    }
  ];

  return (
    <section className="geometric-prism-container">

         <h2 className="display-4 ecosystem-title mb-2 text-dark">
                   Foundations of <span className="ecosystem-secondary-info"> Our Lending Approach</span>
                </h2>
      <p className="differentiator-text">
        Driving growth and providing fast, reliable payday loan services to our customers.
      </p>
      <div className="prism-grid-wrapper">
        {prismData.map((item) => (
          <div key={item.id} className="prism-cell">
            <div className="prism-block">
              <div className="prism-content">
                <div className="prism-icon">{item.icon}</div>
                <div className="prism-title">{item.title}</div>
              </div>
            </div>
            <div className="prism-description-box">
              <p className="description-text">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default GeometricPrismSection;
